/* eslint-disable react/prop-types */
import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import { Context } from "~context/MainProvider.js";
import { getMenuObj } from "~helpers/menu";
import { menusConfig } from "../../../../constants/admin-bar";
import LayoutSection from "./layout-section";
import PreviewLink from "./preview";
import Logo from "./logo";
import styles from "./bar.module.scss";

const AdminBar = ({ page, marketSections, menu, activeMarket }) => {
  const { setShowTranslationKeys, preview } = useContext(Context) || {};
  const [val, setVal] = useState(false);
  const types = ["operator", "game", "author", "payment_method"];

  const navSection = marketSections?.navigation;
  const footerSection = marketSections?.footer?.extra_fields;
  const menuObj = navSection?.modules
    ? getMenuObj(navSection.modules, menu)
    : null;

  const menus =  menusConfig(menuObj, footerSection, page, types);

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <Logo />
        <ul className={styles.menuList}>
          <li>
            <label className={styles.checkbox} htmlFor="translation">
              <input
                id="translation"
                type="checkbox"
                checked={val}
                name="Show translation keys"
                onChange={() => {
                  setVal(!val);
                  setShowTranslationKeys(!val);
                }}
              />
              Show translation keys
            </label>
          </li>
          <LayoutSection menus={menus} />
          <PreviewLink activeMarket={activeMarket} page={page} preview={preview} />
        </ul>
      </div>
    </div>
  );
};

AdminBar.propTypes = {
  page: PropTypes.shape({
    id: PropTypes.number,
    market_id: PropTypes.number,
    path: PropTypes.string,
  }),
  marketSections: PropTypes.shape({
    navigation: PropTypes.shape({}),
    footer: PropTypes.shape({}),
  }),
  menu: PropTypes.string,
};

export default AdminBar;
